import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { Link, Route, Switch } from 'react-router-dom'
import ServiceList from '../../../containers/services/ServiceList'
import ServiceListColumnsMenu from '../../../containers/services/ServiceListColumnsMenu'
import ServicesSearch from '../../../containers/services/ServicesSearch'
import { SERVICE_LIST_TYPE } from '../../../state/constants/index'
import ServiceListTypeSelector from './ServiceListTypeSelector'

const ServiceListActivePane = ({ match }: RouteComponentProps<any>) => (
  <div>
    {/* <ServiceListHeader /> */}
    <ServiceList type={SERVICE_LIST_TYPE.ACTIVE} />
  </div>
)

const ServiceListArchivedPane = (props: RouteComponentProps<any>) => (
  <div>
    {/* <ServiceListHeader /> */}
    <ServiceList type={SERVICE_LIST_TYPE.ARCHIVED} />
  </div>
)

const ServiceListPane = ({ location, match }: RouteComponentProps<any>) => {
  const type = /\/archived/.test(location.pathname) ? SERVICE_LIST_TYPE.ARCHIVED : SERVICE_LIST_TYPE.ACTIVE
  const url = match.url

  return (
    <div className='pt3'>
      <div className='flex justify-between mb2 align-middle'>
        <ServiceListTypeSelector type={type} url={url} />
        <div className='flex flex-row mr2'>
          <ServicesSearch type={type} />

          <Link className='btn bg-green rounded mr2' to={`/services/create`}>
            <span className='font-white weight-300 align-middle'>+ Create New Service</span>
          </Link>

          <ServiceListColumnsMenu />
        </div>
      </div>

      <Switch>
        <Route path={`${match.path}/archived`} component={ServiceListArchivedPane} />
        <Route path={`${match.path}/active`} component={ServiceListActivePane} />
        <Route path={`${match.path}`} component={ServiceListActivePane} />
      </Switch>
    </div>
  )
}

export default ServiceListPane



// WEBPACK FOOTER //
// ./src/components/services/list/ServiceListPane.tsx